import {Component, inject} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {RouterLink} from '@angular/router'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {
  LogoComponent,
  ToggleButtonComponent
} from '@sparbanken-syd/sparbanken-syd-theme'
import {
  CUSTOMER_PATH,
  CUSTOMER_START,
  MODEL_PORTFOLIO_PATH
} from '../../application/constants'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    LogoComponent,
    RouterLink,
    ToggleButtonComponent,
    MatIconButton
  ],
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  protected readonly service = inject(ConfigService)
  protected readonly CUSTOMER_PATH = CUSTOMER_PATH
  protected readonly MODEL_PORTFOLIO_PATH = MODEL_PORTFOLIO_PATH
  protected readonly CUSTOMER_START = CUSTOMER_START
}
